import { Box, Column, Stack, Text } from 'braid-design-system';
import React from 'react';

import { encodeSvg } from 'src/shared/helpers';

import * as styles from './InfosItem.css';

interface PromosItemProp {
  imgSrc: string;
  description: string;
}

const InfosItem = ({ imgSrc, description }: PromosItemProp) => (
  <Column>
    <Box padding="medium">
      <Stack space="large">
        <Box
          className={styles.image}
          style={{
            backgroundImage: encodeSvg(imgSrc),
          }}
        />
        <Text align="center">{description}</Text>
      </Stack>
    </Box>
  </Column>
);

export default InfosItem;
